import Heading from '../../sharedComponents/Heading/Heading';
import './Careers.scss';
import CareersImage from '../../../assets/CareersImage.svg';
import Button from '../../sharedComponents/Button/Button';
import { ReactComponent as ArrowForward } from '../../../assets/icons/arrow_forward.svg';
import Input from '../../sharedComponents/Input/Input';
import { useEffect, useState } from 'react';
import { useEmailJS } from '../../coreModules/hooks/useEmaiJs';

function Careers() {
  const INITIAL_FORM_DATA = {
    message: '',
    email: '',
    experience: ''
  }
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [errorData, setErrorData] = useState(INITIAL_FORM_DATA);
  const [isBtnDisabled, setBtnDisabled] = useState(true);

  const handleInputChange = (key: string, value: string) => {
    if (value === '') {
      setErrorData((prevState) => ({
        ...prevState,
        [key]: `Enter value for ${key}`
      }))
    }
    else {
      setErrorData((prevState) => ({
        ...prevState,
        [key]: ``
      }))
    }
    const newFormData = {
      ...formData,
      [key]: value

    }
    setFormData(newFormData);
    const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(newFormData?.email?.trim());
    const isValidMessage = /^.{5,1000}$/.test(newFormData?.message?.trim());
    const isValidExperience = /^[0-9]/.test(newFormData?.experience);
    if (!isValidEmail && key === 'email') {
      setErrorData((prevState) => ({
        ...prevState,
        email: 'Enter valid email address'
      }))
    }
    if (!isValidMessage && key === 'message') {
      setErrorData((prevState) => ({
        ...prevState,
        message: 'Enter valid message'
      }))
    }
    if(!isValidExperience && key === 'experience') {
      setErrorData((prevState) => ({
        ...prevState,
        experience: 'Enter Valid Experience'
      }))
    }
    if (isValidEmail && isValidMessage) {
      setBtnDisabled(false);
    }
  }

  const { isLoading, error, sendEmail, success } = useEmailJS({
    serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID_CAREERS!,
    templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CAREERS!,
    publicKey: process.env.REACT_APP_EMAIL_JS_PUBLIC_KEY!,
    formData,
  });


  const handleSubmit = async () => {
    const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email?.trim());
    const isValidMessage = /^.{5,1000}$/.test(formData.message?.trim());

    if (isValidEmail && isValidMessage) {
      setBtnDisabled(false);
      try {
        await sendEmail();
      } catch (error) {
        console.error('Error sending email:', error);
      }
    }
  };

  useEffect(() => {
    if (success) {
      window.alert('Mail Sent Successfully!');
      setFormData(INITIAL_FORM_DATA);
      setErrorData(INITIAL_FORM_DATA);
    }
  }, [success])
  return (
    <div id='alpha-perceptron-careers' className='alpha-perceptron-careers responsiveFlexBox'>
      <div className='alpha-perceptron-careers__container'>
        <div className='alpha-perceptron-careers__container__textContainer'>
          <Heading size='h2' type='primary' theme='dark'>
            Join Our Team
          </Heading>
          <Heading size='h6' type='secondary' theme='dark'>
            We're building the future of AI. <br />
            Join a team of visionary engineers and researchers
          </Heading>
          <img className='alpha-perceptron-careers__container__textContainer__careers-image' src={CareersImage} alt='Join Our Team' />
        </div>
        <div className='alpha-perceptron-careers__container__formContainer'>
          <div className='alpha-perceptron-careers__container__formContainer__form'>
            <div className='alpha-perceptron-careers__container__formContainer__form__inputContainer'>
              <Input
                type="email"
                placeholder="Enter your email"
                value={formData?.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                helperText={errorData?.email}
              />
              <Input
                type="number"
                placeholder="Your Experience"
                value={formData?.experience}
                onChange={(e) => handleInputChange('experience', e.target.value)}
                helperText={errorData?.experience}
              />
              <Input
                type="textarea"
                placeholder="Your Message"
                value={formData?.message}
                onChange={(e) => handleInputChange('message', e.target.value)}
                helperText={errorData?.message}
              />
              <Button disabled={isBtnDisabled} type='secondary' size='medium' icon={<ArrowForward />} onClick={handleSubmit}>
                {isLoading ? 'Sending...' : 'Send Message'}
              </Button>
              {error && <p style={{ color: 'red', fontSize: '1.5vh', fontWeight: '400' }}>{error}</p>}

            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Careers;

